import { ProjectAction } from "../actions/project";
import { SET_PROJECT, CLEAR_PROJECT } from "../constants";

const projectReducer = (state = {}, action: ProjectAction | any) => {
  switch (action.type) {
    case SET_PROJECT: {
      return action.project;
    }
    case CLEAR_PROJECT:
      return {};
    default:
      return state;
  }
};

export default projectReducer;
